interface ToastConfig {
  variant?: "default" | "destructive" | "success"
  description: string
  duration?: number
}

interface ExportMessages {
  ERROR: ToastConfig
}

interface EmailReportMessages {
  EXPORT: ExportMessages
}

export const EMAIL_REPORT_MESSAGES: EmailReportMessages = {
  EXPORT: {
    ERROR: {
      variant: "destructive",
      description: "Erro ao exportar planilha Excel. Tente novamente.",
      duration: 5000,
    },
  },
}
